export const ORDER_STATUS = ['Chưa Duyệt', 'Duyệt', 'Đã hủy']
export const INVOICE_STATUS = [
  {value: 'pending', label: 'Chưa xuất HĐ'}, 
  {value: 'invoiced', label: 'Đã xuất HĐ'}, 
  {value: 'adjusted', label: 'Đã điều chỉnh HĐ'}, 
  {value: 'replaced', label: 'Đã thay thế HĐ'}
]
export const SENTO = 'Super Admin'
export const QR_PREFIX = `${window.location.origin}/add-to-cart/`
export const LIST_PERMISSIONS = {
  DASHBOARD: 'dashboard',
  PRODUCTS: 'products',
  ORDERS: 'orders',
  SUPPLIERS: 'suppliers',
  AGENTS: 'agents',
  WAREHOUSE: 'warehouse',
  ABILITIES: 'abilities',
  DEBTS: 'debts',
  ACCOUNTS: 'accounts',
  STORES: 'stores',
  SALES: 'sales',
  COMBO: 'combo',
  CONSIGN_PRODUCTS: 'new_consign_pds',
  CARTS: 'carts',
  WARRANTY_REFUND: 'warranty_refund',
  RECEIPT_IN: 'receipts_in',
  CREATE_RECEIPT_BY_IMG: 'create_receipt_by_img',
  FIND_PD_IN_RECEIPTS: 'find_pd_in_receipts',
  IMPORT_REQUEST: 'import_request',
  RECEIPT_OUT: 'receipts_out',
  ACCOUNT_BOOKS: 'account_books',
  ACCOUNT_BOOKS_CASH: 'account_books_cash',
  ACCOUNT_BOOKS_BANK: 'account_books_bank',
  ACCOUNT_BOOKS_SALE: 'account_books_sale',
  ACCOUNT_BOOKS_WAREHOUSE: 'account_books_warehouse',
  ACCOUNT_BOOKS_EXPENSE: 'account_books_expense',
  ACCOUNT_BOOKS_TAX: 'account_books_tax',
  ACCOUNT_BOOKS_PAYROLL: 'account_books_payroll',
  RECIEPT_VOUCHER: 'receipt_voucher',
  PAYMENT_VOUCHER: 'payment_voucher',
  PAYMENT_REQUEST: 'payment_request',
  CASH_BANK_BOOK: 'cash_bank_book',
  PURCHASED_SEARCH: 'purchased_search',
  PRODUCT_SALES_STATISTIC: 'product_sales_statistic',
  AGENT_DEBT: 'supplier_debt',
  SUPPLIER_DEBT: 'agent_debt',
  IMPORT_OPEN_STOCK: 'import_open_stock',
  CANCEL_DELETE_ORDERS: 'cancel_delete_orders',
  CANCEL_DELETE_RECEIPTS: 'cancel_delete_receipts',
  ABILITIES_EDIT: 'abilities_edit',
  ABILITIES_DELETE: 'abilities_delete'
}

export const APPROVED_STT = 'Duyệt'
export const NOT_APPROVED_STT = 'Chưa Duyệt'
export const CANCELED_STT = 'Đã hủy'
export const PAYMENT_VOUCHER_CODE = 'payment_voucher'
export const RECIEPT_VOUCHER_CODE ='receipt_voucher'
export const PAYMENT_VOUCHER = 'Phiếu chi'
export const RECIEPT_VOUCHER ='Phiếu thu'
export const ABILITIES_TYPES = [
  {id: 'payment_voucher', label: PAYMENT_VOUCHER},
  {id: 'receipt_voucher', label: RECIEPT_VOUCHER}
]
export const BANKING_METHOD = 'Chuyển khoản'
export const CASH_METHOD ='Tiền mặt'
export const ABILITIES_PAYMENT_METHOD = [
  {id: 'banking', label: BANKING_METHOD},
  {id: 'cash', label: CASH_METHOD}
]

export const PAID = 'Đã thanh toán'
export const UNPAID ='Chưa thanh toán'
export const PAID_PART ='Thanh toán một phần'
export const PAYMENT_STATUS = [
  {id: '0', label: UNPAID},
  {id: '1', label: PAID},
  {id: '2', label: PAID_PART}
]

export const IMAGES_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
export const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
export const DEFAULT_PER_PAGE = 50;
export const CONSIGN_PD_STATUS = [
  {id: 'new', label: 'Mới'},
  {id: 'approved', label: 'Đã duyệt'},
  {id: 'inactive', label: 'Ngừng bán'},
  {id: 'rejected', label: 'Từ chối'}
]
export const IMPORT_REQUEST_EDITABLE_STATUS = ['draft', 'new'];

export const LIST_SCREENS = [
  {
    model: LIST_PERMISSIONS.DASHBOARD,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.PRODUCTS,
    childs: [
      {
        model: LIST_PERMISSIONS.PRODUCTS,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.COMBO,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.CONSIGN_PRODUCTS,
        childs: []
      }
    ]
  },
  {
    model: LIST_PERMISSIONS.ORDERS,
    childs: [
      {
        model: LIST_PERMISSIONS.ORDERS,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.CANCEL_DELETE_ORDERS,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.PURCHASED_SEARCH,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.PRODUCT_SALES_STATISTIC,
        childs: []
      }
    ]
  },
  {
    model: LIST_PERMISSIONS.SUPPLIERS,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.AGENTS,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.WAREHOUSE,
    childs: [
      {
        model: LIST_PERMISSIONS.CARTS,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.WARRANTY_REFUND,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.WAREHOUSE,
        label: 'Tồn kho',
        childs: []
      },
      {
        model: LIST_PERMISSIONS.RECEIPT_IN,
        childs: [
           {
              model: LIST_PERMISSIONS.CREATE_RECEIPT_BY_IMG,
              childs: []
            },
            {
              model: LIST_PERMISSIONS.CANCEL_DELETE_RECEIPTS,
              childs: []
            },
            {
              model: LIST_PERMISSIONS.FIND_PD_IN_RECEIPTS,
              childs: []
            },
            {
              model: LIST_PERMISSIONS.IMPORT_REQUEST,
              childs: []
            }
        ]
      },
      {
        model: LIST_PERMISSIONS.RECEIPT_OUT,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.IMPORT_OPEN_STOCK,
        childs: []
      }
    ]
  },
  {
    model: LIST_PERMISSIONS.ABILITIES,
    childs: [
      {
        model: LIST_PERMISSIONS.RECIEPT_VOUCHER,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.PAYMENT_VOUCHER,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.PAYMENT_REQUEST,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.CASH_BANK_BOOK,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ABILITIES_EDIT,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ABILITIES_DELETE,
        childs: []
      }
    ]
  },
  {
    model: LIST_PERMISSIONS.DEBTS,
    childs: [
      {
        model: LIST_PERMISSIONS.AGENT_DEBT,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.SUPPLIER_DEBT,
        childs: []
      }
    ]
  },
  {
    model: LIST_PERMISSIONS.ACCOUNTS,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.STORES,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.SALES,
    childs: []
  },
  {
    model: LIST_PERMISSIONS.ACCOUNT_BOOKS,
    childs: [
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_CASH,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_BANK,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_SALE,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_WAREHOUSE,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_EXPENSE,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_TAX,
        childs: []
      },
      {
        model: LIST_PERMISSIONS.ACCOUNT_BOOKS_PAYROLL,
        childs: []
      }
    ]
  }
]

export const HKGLogoSettings = {
  src: '/media/logos/hkg-logo.png',
  width: 100,
  height: 100,
  excavate: false,
  opacity: 0.8
}

export const PAYMENT_IMPORT_HEADERS = [
  'ngày giao dịch',
  'số tham chiếu',
  'số tiền ghi nợ',
  'số tiền ghi có',
  'phương thức',
  'mô tả',
  'mục đích',
  'nhóm chi phí'
]

export const BUSINESS_TYPE_COMPANY = 1
export const BUSINESS_TYPE_HOUSE_HOLD_1 = 2
export const BUSINESS_TYPE_HOUSE_HOLD_2 = 3
export const BUSINESS_TYPE_HOUSE_HOLD_3 = 4
export const BUSINESS_TYPE_HOUSE_HOLD_4 = 5
export const TAX_BY_SALES_AMOUNT = 'sales_amount';
export const TAX_BY_PROFITS_AMOUNT = 'profits_amount';

export const DECIMALS = {
  'default': 0,
  'decimal_2': 2
}

export const DH_LINE_STATUS_LABEL = {
  'not_yet': {
    'label': 'Chưa đối soát',
    'color': 'warning'
  },
  'verified':  {
    'label': 'Đã đối soát',
    'color': 'success'
  },
  'missing': {
    'label': 'Chưa có dữ liệu',
    'color': 'danger'
  },
  'mismatch': {
    'label': 'Chưa khớp',
    'color': 'danger'
  },
  'matched': {
    'label': 'Đã khớp',
    'color': 'success'
  }
}

export const PAYMENT_VOUCHER_TYPE_OPTIONS = [
  {
    value: 'debt',
    label: 'Công nợ'
  },
  {
    value: 'withdraw',
    label: 'Rút tiền mặt'
  },
  {
    value: 'deposit',
    label: 'Nộp tiền ngân hàng'
  },
  {
    value: 'bank_fee',
    label: 'Phí ngân hàng'
  },
  {
    value: 'personal_used',
    label: 'Chi tiêu cá nhân'
  },
  {
    value: 'tax',
    label: 'Thuế'
  },
  {
    value: 'electric',
    label: 'Chi phí điện'
  },
  {
    value: 'water',
    label: 'Chi phí nước'
  },
  {
    value: 'telecom',
    label: 'Chi phí viễn thông'
  },
  {
    value: 'rent',
    label: 'Chi phí thuê'
  },
  {
    value: 'manage',
    label: 'Chi phí quản lý'
  },
  {
    value: 'payroll',
    label: 'Chi phí nhân sự'
  },
  {
    value: 'depreciation',
    label: 'Chi phí khấu hao'
  },
  {
    value: 'interest',
    label: 'Chi phí lãi vay'
  },
  {
    value: 'other',
    label: 'Chi phí khác'
  },
  {
    value: 'sales_refund',
    label: 'Hoàn tiền'
  }
];

export const FORCE_BANKING_METHOD = ['withdraw', 'bank_fee', 'deposit'];

export const RECEIPT_VOUCHER_TYPE_OPTIONS = [
  {
    value: 'sales',
    label: 'Công nợ'
  },
  {
    value: 'withdraw',
    label: 'Rút tiền mặt'
  },
  {
    value: 'deposit',
    label: 'Nộp tiền ngân hàng'
  },
  {
    value: 'bank_disburses_funds',
    label: 'Ngân hàng giải ngân'
  },
  {
    value: 'interest_on_deposit',
    label: 'Lãi tiền gửi'
  },
  {
    value: 'debt_refund',
    label: 'Hoàn tiền'
  }
];

export const DEBIT_TRANS_TYPE_OPTIONS = [
  {
    value: 'purchase',
    label: 'Thanh toán tiền NCC'
  },
  {
    value: 'withdraw',
    label: 'Rút tiền'
  },
  {
    value: 'salary',
    label: 'Chi lương'
  },
  {
    value: 's_insurance',
    label: 'Bảo hiểm xã hội'
  },
  {
    value: 'h_insurance',
    label: 'Bảo hiểm sức khỏe'
  },
  {
    value: 'u_insurance',
    label: 'Bảo hiểm thất nghiệp'
  },
  {
    value: 'tax',
    label: 'Đóng thuế'
  },
  {
    value: 'bank_fee',
    label: 'Phí ngân hàng'
  },
  {
    value: 'personal_used',
    label: 'Chi tiêu cá nhân'
  },
  {
    value: 'interest',
    label: 'Lãi vay'
  },
  {
    value: 'other',
    label: 'Khác'
  }
]

export const CREDIT_TRANS_TYPE_OPTIONS = [
  {
    value: 'sales',
    label: 'Bán hàng'
  },
  {
    value: 'deposit',
    label: 'Nộp tiền ngân hàng'
  },
  {
    value: 'bank_disburses_funds',
    label: 'Ngân hàng giải ngân'
  },
  {
    value: 'interest_on_deposit',
    label: 'Lãi tiền gửi'
  },
  {
    value: 'other',
    label: 'Khác'
  }
]

export const LOCAL_PRINTER_KEY = 'printer'
